import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import { createdUpdatedInfo } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedFlightId: string;
    hard: boolean;
    deleteFlight: () => Promise<void>;
}

export default function ModalConfirm ({
    modal,
    setModal,
    selectedFlightId,
    hard,
    deleteFlight
}: Props) {

    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Confirm Delete</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h1>Are you sure you want to {hard ? 'Hard' : 'Soft'} delete Flight {selectedFlightId}</h1>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'delete'} onClick={() => deleteFlight()} simulateLoading />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;